import React, { useContext, useState } from 'react';
import './game-thumbnail.scss';

// Assets
import { ReactComponent as StarIcon } from '../../assets/star.svg';
import { ReactComponent as DeleteIcon } from '../../assets/delete.svg';

// Libs
import LazyLoad from 'react-lazyload';

// Contexts
import { StateContext } from '../../contexts/state';
import { useEffect } from 'react';

// Service
import messenger from '../../services/messenger';

const GameThumbnail = ({ id, icon, title, rating, onClick, category, sIcon, deleteFav = false }) => {
	const dataContext = useContext(StateContext);

	const [hovered, setHovered] = useState(false);
	const [isFavorite, setIsFavorite] = useState(false);

	useEffect(() => {
		if (dataContext.data.favorites?.find(game => game === id)) setIsFavorite(true);
	}, []);

	const onDeleteClick = () => {
		dataContext.setFavorite(id, false);
		messenger.log({ eventAction: `Favorite Remove`, eventLabel: title });
	};

	return (
		<div
			className="game-thumbnail"
			onClick={onClick}
			onMouseEnter={() => setHovered(true)}
			onMouseLeave={() => setHovered(false)}
		>
			<div style={{ height: '100%', width: '100%' }}>
				<img  loading='lazy' src={icon} className="game-thumbnail__icon" alt="" />
				{deleteFav && hovered && (
					<DeleteIcon className="game-thumbnail__delete-icon" alt="" onClick={onDeleteClick} />
				)}
			</div>
			<div className="game-thumbnail__data-wrapper">
				<div className="game-thumbnail__data-wrapper__data">
					<div>
						<img loading='lazy' src={sIcon} className="game-thumbnail__data-wrapper__data__icon" />
					</div>
					<div className="game-thumbnail__data-wrapper__data__text">
						<span className="game-thumbnail__data-wrapper__data__text__title">{title}</span>
						<span className="game-thumbnail__data-wrapper__data__text__rating">
							<p className="game-thumbnail__data-wrapper__data__text__rating__num">{rating.toFixed(1)}</p>
							<StarIcon className="game-thumbnail__data-wrapper__data__text__rating__star" />
							<span className="game-thumbnail__data-wrapper__data__text__rating__category">
								{category}
							</span>
						</span>
					</div>
				</div>
			</div>
		</div>
	);
};

export default GameThumbnail;
